<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Select from "@/components/c-select";
// import Input from "@/components/c-input";
// import Button from "@/components/c-button";
import moment from 'moment'
import { saleStageService } from "../../../../services/reportservice/salestage.service.js";
import { priceversionService } from "../../../../services/propertyservice/priceversion.service";
import { servicehelpers } from "../../../../services/servicehelpers";


/* eslint-disable no-console */
export default {
  page: {
    title: "Phase Sales Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { 
    Layout, 
    PageHeader, 
    // Button,
    // Input,
    Select, 
  },
  data() {
    return {
      title: "Phase Sales Report",
      data: [],
      total: [],
      date: '',
      projects: {},
      projectName: 'លំនៅឋាន អេច សែនសុខ (RHSS)',
      versionName: 'តម្លៃលក់គ្រាដើម',
      user: JSON.parse(localStorage.getItem('user')),

      dataStartDate: '',
      dataEndDate: '',
      dataProjectId: 1,

      priceVersionData: {},
      dataPriceVersion: 1
    };
  },
  mounted() {
    //this.loadingData(this.$route.params.id);
    this.loadingData();
    
  },
  methods: {
    
     
    loadingData: function() {
      let param = `?project_id=${this.dataProjectId}&version_id=${this.dataPriceVersion}`;
      saleStageService.getSaleStage(param)
        .then(response => {
          console.log(response);
          this.data = response.data.list;
          this.total = response.data.total;
          this.loadingProjectData()
          this.loadingPriceVersionData(this.dataProjectId);
        });
      
        
    },

    loadingProjectData: function() {
      servicehelpers.getProjectData().then(response => {
        this.projects = response.data;
      });
    },

    loadingPriceVersionData: function(projectId) {
      let param = `?clause={"clause":[{"conjuction":"and","price_versions.project_id":{"value":${projectId}}}]}`;
      priceversionService.getList(param).then(response => {
        this.priceVersionData = response;
        // let obj = this.priceVersionData.data[this.priceVersionData.data.length - 1];
        // this.dataPriceVersion = obj ? obj.id : this.dataPriceVersion;

      });
    },

    priceVersionChanged: function(event) {
      console.log(event);
      this.getVersionById(this.dataPriceVersion);
      this.loadingData(this.dataProjectId, event);
    },

    getVersionById: function(id){
      priceversionService.getOne(id).then(response => {
        // console.log(response.data.name);
        this.versionName = response.data.name;
        this.dataPriceVersion = response.data.id;
      });
    },
    projectChanged: function(event) {
      this.loadingData(event);
    },
    dateFormat: function(value){
      return moment(String(value)).format('DD/MM/YYYY');
    },
    moment: function () {
      return moment();
    },
    discountPrice(price, discount, dis_type) {
        let total = 0;
        if(dis_type==1){
          total = price * discount / 100;
        }else{
          total = discount
        }
        return total
    },
    formatCurrency(value, sign = '$', decimal = '.00') {
      if(value == 0 ){
        return '';
      }

      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },
    print() {
      window.print();
    },
    totalCount(column_name, type=0){
      let total = 0;
      this.data.map(function(dd){

        if(dd.seller_name && column_name == 'seller_name' && dd.property_status_id == type){
          total++;
        }
        if((dd.agency_name && column_name == 'agency_name') && (dd.agency_name !=  dd.seller_name) && dd.seller_name == null && dd.property_status_id == type){
          total++;
        }
        if(dd.property_status_id == 2 && column_name == 'booking'){
          total++;
        }

        if(dd.property_status_id == 3 && column_name == 'sold'){
          total++;
        }

        if(column_name == 'total_property'){
          total++;
        }
      });

      return total;
      // return this.data.reduce(function (sum, item) {
      //   if(item.seller_name != '')
      //   return sum + item[column_name];
        
      // }, 0)
    },
    totalPrice(col_name) {
      return this.data.reduce(function (sum, item) {
        return sum + item[col_name];
      }, 0)
    },
  },
  
  computed: {
    countPropertyUnit(){
       return this.data.reduce(function (count) {
        let total = count +1;
        return total
      }, 0)
    }
    
  }
};

</script>

<template>
  <Layout>
    <PageHeader @click="print()" :add="{icon: 'bx bx-printer', title: 'general.print'}" :title="$t('report.sale-stage.text')" />
      <div id="print-area">
        <!-- <center> -->
          <div class="row search-area">
              
              <div class="col-sm-2">
                <Select
                  :id="'id'"
                  :text="'name'"
                  :editable="true"
                  @change="projectChanged"
                  :list="{data: this.projects}"
                  v-model="dataProjectId"
                /> 
              </div>
              <div class="col-sm-2">
                <Select 
                  :text="'name'"
                  :id="'project_id'"
                  @change="priceVersionChanged" 
                  v-model="dataPriceVersion"
                  :list="this.priceVersionData"
                 
                /> 
              </div>
              <!-- <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'start_date'"
                  v-model="dataStartDate"
                /> 
              </div>
              <div class="col-sm-2">
                <Input 
                  :type="'date'"
                  :id="'end_date'"
                  v-model="dataEndDate"
                /> 
              </div> -->
              <!-- <div class="col-sm-2">
                <Button v-bind:icon="'bx bx-search'"
                  @click="submitSearch()" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'primary'"
                  v-bind:title="$t('general.search')" 
                />
              </div> -->
          </div>
          <div class="col dblack box-a4l">
            <table width="100%" class="content-general bottom">
              <tr>
                <td width="9%"><p>&nbsp;</p></td>
                <td width="50%"><p>&nbsp;</p></td>
                <td width="35%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td><img src="@/assets/images/h-logo.svg" alt width="80" /></td>
                <td>
                  <p class="khb h4"><b>ក្រុមហ៊ុនលំនៅឋាន<span class="g-color"> អេចស៊ី </span>ឯ.ក</b></p>
                  <p class="enb h5"><b>LOMNOV THAN <span class="g-color">HC</span> CO., LTD</b></p>
                  <p class="khs h8">អាសយដ្ឋានដីឡូតិ៍លេខៈ ៧៤២ ផ្លូវលេខៈ ១៩៥២ ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
                  <p class="khs h8">ទូរស័ព្ទលេខៈ 092 92 66 88 | 086 62 66 89 Email: account@h-residence.net</p>
                </td>
                <td class="">
                    <p class="khb"><u>{{$t('report.sale-stage.text')}}</u></p>
                    <p class="khb"><u>គម្រោង: {{this.projectName}}</u></p>
                    <p class="khb"><u>ដំណាក់កាល: {{this.versionName}}</u></p>
                </td>
              </tr>
              
            </table>
            <br/>
            <table class="content-general h8 project-sumary-table report-table" width="100%">
              
                <tr class="thead">
                  <th rowspan="2">{{$t('general.number')}}</th>
                  <th rowspan="2">{{$t('report.income_expense.date')}}</th>
                  <th rowspan="2">{{$t('general.contract')}}</th>
                  <th style="width:7em;" colspan="3">{{$t('property.text')}}</th>
                  <th rowspan="2">{{$t('general.unit_price')}}</th>
                  <th rowspan="2">{{$t('booking.discount')}}</th>
                  <th rowspan="2">{{$t('general.sale_price')}}</th>
                  <th rowspan="2">{{$t('general.paid_amount')}}</th>
                  <th rowspan="2">{{$t('general.pending_amount')}}</th>
                </tr>
                <tr class="thead">
                  <th>{{$t('property.group')}}</th>
                  <th>{{$t('report.booking.unit')}}</th>
                  <th>{{$t('report.booking.size')}}</th>
                </tr>
               
              <tbody>
                <tr v-for="(list, index) in data" :key="index" >

                  <td>{{index + 1}}</td>
                  <td>{{dateFormat(list.sale_date)}}</td>
                  <td>{{list.name}}</td>
                  <td>{{list.property_group}}</td>
                  <td>{{list.code}}</td>
                  <td>{{formatCurrency(list.net_size, '')}}M<sup><small>2</small></sup></td>

                  <!-- <td>{{formatCurrency(list.net_size, '')}}</td> -->

                  <td>{{formatCurrency(list.amount)}}</td>
                  <td>{{formatCurrency(list.discount)}}</td>
                  <td>{{formatCurrency(list.sale_price)}}</td>
                  
                  <td>{{formatCurrency(list.paid_amount)}}</td>
                  <td>{{formatCurrency(list.balance)}}</td>
                 
                </tr>
              </tbody>
                <tr class="tfoot" v-if="data">
                  <td colspan="2" class="border text-end pe-2">{{$t('stock-owner.total')}}</td>
                  <td class="border">{{(countPropertyUnit)}}</td>
                  <td class="border"></td>
                  <td class="border"></td>
                  <td class="border"></td>
                  <td class="border">{{formatCurrency(totalPrice('amount'))}}</td>
                  <td class="border">{{formatCurrency(totalPrice('discount'))}}</td>
                  <td class="border">{{formatCurrency(totalPrice('sale_price'))}}</td>
                  <td class="border">{{formatCurrency(totalPrice('paid_amount'))}}</td>
                  <td class="border">{{formatCurrency(totalPrice('balance'))}}</td>
                </tr>
            </table>
            <br>
            <div class="row">
              <div class="col-sm-8">
                <table class="content-general h8 project-sumary-table report-table" width="100%">
                  
                    <tr class="thead">
                      <th>អចលនទ្រព្យសរុប</th>
                      <th>ចំនួនយូនីត</th>
                      <th>តម្លៃឡើង</th>
                      <th>តម្លៃ</th>
                    </tr>
                 
                  <tbody>
                    <tr>
                      <td class="text-start">{{ total.price_version.name }}</td>
                      <td>{{ total.count_unit }}</td>
                      <td>{{ formatCurrency(total.different_price) }}</td>
                      <td>{{ formatCurrency(total.total_price) }}</td>
                    </tr>
                    <tr>
                      <td  class="text-start">បានលក់</td>
                      <td>{{ total.sold_unit }}</td>
                      <td></td>
                      <td>{{ formatCurrency(total.sold_price) }}</td>
                    </tr>
                    <tr>
                      <td  class="text-start">អចលនទ្រព្យនៅលស់</td>
                      <td>{{ total.pendding_unit }}</td>
                      <td></td>
                      <td>{{ formatCurrency(total.pendding_price) }}</td>
                    </tr>
                  
                  </tbody>
                </table>
              </div>
            </div>
            
            <div class="row mt-3 report-table">
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព</p>
                  <p class="khm sub-title">អគ្គនាយកក្រុមហ៊ុន</p>
                  <br>

                  <p>លី ប៊ុនហ៊ាង</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកហិរញ្ញវត្ថុ</p>
                  <br><br>

                  <p>លឹម ទ្រី</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>នាយកផ្នែកបច្ចេកទេស</p>
                  <br><br>

                  <p>សាយនី យូស៊ន់</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>ប្រធានគ្រប់គ្រងទូទៅ</p>
                  <br><br>

                  <p></p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
              
              <div class="col">
                <center>
                  <p>បានពិនិត្យនិងឯកភាព<br>អ្នកធ្វើរបាយការណ៍</p>
                  <br><br>

                  <p>{{this.user.name}}</p>
                  <p>ថ្ងៃទីៈ..........................</p>
                </center>
              </div>
            </div>
          </div>  
        <!-- </center> -->
      </div>
    <!-- end row -->
  </Layout>
</template>